var map = {
	"./ab_logo_icon.svg": 962,
	"./bing_logo_icon.svg": 85,
	"./facebook_logo_icon.svg": 66,
	"./fb_logo_icon.svg": 963,
	"./google_logo_icon.svg": 65,
	"./instagram_logo_icon.svg": 68,
	"./sc_logo_icon.svg": 964,
	"./tiktok_logo_icon.svg": 216
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 95;


//////////////////
// WEBPACK FOOTER
// ./src/assets/images ^\.\/.*_logo_icon\.svg$
// module id = 95
// module chunks = 0